import React, { Component } from 'react';
import T from 'prop-types';
// redux
import { connect } from 'react-redux';
// styles
import Color from 'color';
import classnames from 'classnames/bind';
import styles from './Preloader.mod.css';

let cx = classnames.bind(styles);

class Preloader extends Component {
  getStyle = () => {
    const { custom, user } = this.props;
    const color = (user && user.profile_color) || '#33C370';

    if (!custom) {
      return null;
    }

    const lightColor = Color(color).fade(0.6);

    return {
      border: `4px solid ${lightColor}`,
      borderLeft: `4px solid ${color}`
    };
  };

  render() {
    const { isActive, className = '' } = this.props;
    const style = this.getStyle();
    return (
      <div style={style} className={cx('preloader', className, { isActive })} />
    );
  }
}

Preloader.propTypes = {
  isActive: T.bool,
  custom: T.bool,
  className: T.string
};

export default connect(state => ({
  user: state.auth.user
}))(Preloader);



// WEBPACK FOOTER //
// ./src/components/Preloader/Preloader.jsx